import React from "react";
import {
  IoIosWallet,
  IoIosCheckmarkCircle,
  IoIosApps,
  IoIosTime,
} from "react-icons/io";

export default function WalletCardSelect({
  selected,
  data,
  onClick,
  inactive = false,
  lastUsedLabel,
}) {
  const isAll = data.id === "0";
  return (
    <li
      className={`wallet-card wallet-card--select ${
        selected ? "wallet-card--selected" : ""
      } ${isAll ? "wallet-card--all" : ""} ${
        inactive ? "wallet-card--inactive" : ""
      }`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick(e)}
      aria-pressed={selected}
    >
      <span className="wallet-card__rail" aria-hidden />
      <span className="wallet-card__icon">
        {isAll ? <IoIosApps /> : <IoIosWallet />}
      </span>
      <div className="wallet-card__body">
        <div className="wallet-card__name">{data.name}</div>
        {inactive && lastUsedLabel ? (
          <div className="wallet-card__desc wallet-card__last-used">
            <IoIosTime /> {lastUsedLabel}
          </div>
        ) : (
          data.description && (
            <div className="wallet-card__desc">{data.description}</div>
          )
        )}
      </div>
      <span className="wallet-card__radio" aria-hidden>
        {selected ? (
          <IoIosCheckmarkCircle className="wallet-card__radio--checked" />
        ) : (
          <span className="wallet-card__radio-empty" />
        )}
      </span>
    </li>
  );
}
